import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7227d4fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "journalReference" }, "Journal Reference:", -1))
const _hoisted_5 = { id: "journalReference" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "accountingDate" }, " Accounting Date:", -1))
const _hoisted_8 = { id: "accountingDate" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "headerDescription" }, "Header Description:", -1))
const _hoisted_11 = { id: "headerDescription" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "headerDescription" }, "Owner ID:", -1))
const _hoisted_14 = { id: "headerDescription" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"margin-top":"15px"},
    class: "uderscore",
    for: "market"
  }, "Line Items :")
], -1))
const _hoisted_16 = { style: {"padding-bottom":"10px"} }
const _hoisted_17 = {
  type: "button",
  class: "overflow-text"
}
const _hoisted_18 = { style: {"display":"flex"} }
const _hoisted_19 = {
  key: 0,
  class: "debit-credit-mismatch"
}
const _hoisted_20 = { style: {"grid-column":"span 2","display":"flex","justify-content":"center","gap":"10px","padding-top":"10px"} }
const _hoisted_21 = ["disabled", "title"]

import { computed, ref } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "./Popup.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { manualJournal} from "@/services/network";
import IManualJournal from "@/Interfaces/Journaling/ManualJournal/IManualJournal";
import Table from "@/components/TablePersistentChecking.vue";
import { DisplayableKeys } from "@/services/SorterService";
import IManualJournalPreviewTable from "@/Interfaces/Journaling/ManualJournal/IPostManualJournalPreviewTable";
import IManualJournalBody from "@/Interfaces/Journaling/ManualJournal/IManualJournalBody";
import { authService } from "@/auth/authSingleton";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManualJournalPopUp',
  props: {
    modelValue: { type: Boolean },
    previewData: {},
    previewTable: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const postRequestPayload = ref<IManualJournalBody>()
const labels = ["Account", "Description", "Debit Amount", "Credit Amount", "Tax Code", "Tax Return"]
const working = ref(false);
const cols: DisplayableKeys<IManualJournalPreviewTable>[] = [
    "Account",
    "Description", 
    "DebitAmount",
    "CreditAmount", 
    "TaxCode", 
    "TaxReturn"
];
const SummaryCols: DisplayableKeys<IManualJournalPreviewTable>[] = ["DebitAmount", "CreditAmount"]
    const totalDebit = computed(() =>
  Math.round(props.previewTable.reduce((sum, item) => sum + (Number(item.DebitAmount) || 0), 0) * 100) / 100
);

const totalCredit = computed(() =>
  Math.round(props.previewTable.reduce((sum, item) => sum + (Number(item.CreditAmount) || 0), 0) * 100) / 100
);
const SummaryValues = computed(() => [totalDebit.value, totalCredit.value]);

const ManualJournalPopUpStatus = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const props = __props;
const emits = __emit;

function formatEnumValue (string: string){
    return string.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (word) => word.toUpperCase());
};
function closeChild(){
    ManualJournalPopUpStatus.value = false;
}
async function PostManualJournalEntry(){
    
    postRequestPayload.value = {
        ...props.previewData, 
        LineItems: props.previewTable, 
        UserName: authService.getEmailAddress(),
        JournalReference: props.previewData.JournalReference == "Auto Generated" ? "" : props.previewData.JournalReference
    }
    if(working.value) return;    
    const closeSpinner = useSpinnerPopup().show();
    try{
        working.value=true
        if(postRequestPayload.value == undefined){
            throw new Error("Post request payload is not defined")
        }else{
            await manualJournal.post(postRequestPayload.value)
            useNotifierWithErrFormatter().success({ msg: "Manual Journal Entry Successfully Registered." });
            emits("confirm");
            closeChild()
        }
    }catch(error){
        useNotifierWithErrFormatter().error({error});
    }
    closeSpinner()
    working.value=false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: ManualJournalPopUpStatus.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ManualJournalPopUpStatus).value = $event)),
    title: "Post Manual Journal Entry",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (PostManualJournalEntry()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.previewData?.JournalReference), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.previewData?.AccountingDate), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.previewData?.HeaderDescription), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.previewData?.OwnerID), 1)
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(Table, {
              Rows: _ctx.previewTable,
              Cols: cols,
              Labels: labels,
              SummaryCols: SummaryCols,
              SummaryValues: SummaryValues.value,
              ref: "table"
            }, {
              Description: _withCtx((props) => [
                _createElementVNode("button", _hoisted_17, _toDisplayString(props.value.Description), 1)
              ]),
              Account: _withCtx((props) => [
                _createElementVNode("span", _hoisted_18, _toDisplayString(formatEnumValue(props.value.Account)), 1)
              ]),
              _: 1
            }, 8, ["Rows", "SummaryValues"])
          ]),
          (totalCredit.value != totalDebit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Debit and credit amounts must be equal "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "submit-btn line-item-btn",
              disabled: totalCredit.value != totalDebit.value,
              title: totalCredit.value != totalDebit.value? 'Total debit must equal total credit' : 'Submit Manual Journal'
            }, " Submit ", 8, _hoisted_21)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})